<template>
    <validation-observer ref="longtextForm">
        <div>
            <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
                <validation-provider v-slot="{errors}" :rules="question.mandatory ? 'required' : ''">


                    <div class="text-attribute">
                        <label :for="id" :class="{' col-md-3 col-xs-4' : isInquiry , 'attribute-label' : !isInquiry}">
                            {{ question.question_text }}
                        </label>

                        <div :class="{' col-md-9 col-xs-8' : isInquiry}">
                            <textarea  :id="id" :name="name" v-model="question.value" @blur="updateText"
                                       class="form-control new-inputs">{{question.answer_text_names}}</textarea>
                            <input type="hidden" :value="id" name="questions[]">
                            <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
                        </div>

                    </div>

                    <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>
                </validation-provider>
            </div>
        </div>
    </validation-observer>
</template>


<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormLongtext",
    props: {
      value: {
            type: Object,
        },
        isPopUp:false,
        viewPage:false,
        isInquiry:false,
        inquiryId:0
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
      return {
        question: this.value
      }
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        }
    },
    methods: {
        // triggerChange() {
        //     EventBus.$emit('onServiceCustomFieldSelected', this.question.service_id, this.clone)
        // },
        // addEventListeners() {
        //
        //     EventBus.$on('onServiceAttributesValidation', async (verify) => {
        //         let validated = await this.$refs.longtextForm.validate();
        //         if (!validated) {
        //             /** If there is a validation error then show the validation and open collapsed services  **/
        //             EventBus.$emit('onCollapseService', this.question)
        //
        //         }
        //         verify(validated)
        //     })
        //
        //
        // },
        // onChange(event) {
        //     this.question.value = event.target.value
        //     this.$emit('input', event.target.value)
        // },
        addEventListeners() {
            EventBus.$on('onFormsAndCheckListsValidation', async (verify) => {
                if(this.$refs.longtextForm){
                    let validated = await this.$refs.longtextForm.validate();
                    verify(validated)
                }
            })
        },
        removeEventListeners(){
            EventBus.$off('onFormsAndCheckListsValidation');
        },
        setValue(data) {
            if(data){
                this.question.value = data;
            }
        },
        updateText(){
            if(this.viewPage && this.isInquiry){
                updateFormQuestionOnViewInquiry( this.question.value, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
            }
        }
    },
    mounted() {
        this.addEventListeners()
        this.setValue(this.question.answer_text_names)

    },
    watch: {
        question: {
            handler: function (question) {
                this.$emit('input', question)
            },
            deep: true
        }
    },
    destroyed() {
        this.removeEventListeners()
    }
}
</script>

<style scoped>
.p-0-1{
    padding:0px 1px;
}
@media screen and (min-width: 768px) and (max-width: 1440px) {
    .change-form-list-in-inquiry {
        margin-left: 15px !important;

    }

}

@media screen and (min-width: 1px) and (max-width: 428px) {
    /*@media only screen and (max-width: 428px) {*/
    .change-form-list-in-inquiry {
        width: 57%;
        margin-left: 15px !important;
    }

}

@media screen and (min-width: 1441px) {
    .change-form-list-in-inquiry {
        margin-left: 15px !important;
    }

}

</style>